import { buddyStage } from "@little-finds/core";
export function Buddy({
  fed = 0,
  feeding = false,
  compact = false,
}: {
  fed?: number;
  feeding?: boolean;
  compact?: boolean;
}) {
  const stage = buddyStage(fed),
    belly = stage * 5;
  return (
    <svg
      className={`buddy-art ${feeding ? "feeding" : ""}`}
      viewBox="0 0 260 190"
      role="img"
      aria-label={`Your beagle, cozy level ${stage + 1}`}
    >
      <ellipse cx="138" cy="172" rx="85" ry="8" fill="#ddd5bd" opacity=".5" />
      <g
        stroke="#343b35"
        strokeWidth="3.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <path d="M199 108 Q233 72 225 105 Q223 121 204 131" fill="#fffdf4" />
        <ellipse
          cx="154"
          cy={129 - belly * 0.15}
          rx={53 + belly}
          ry={34 + belly * 0.45}
          fill="#fffdf4"
        />
        <path
          d={`M126 ${101 - belly * 0.3} Q154 89 178 110 Q192 138 171 152 Q145 155 132 136Z`}
          fill="#b98b61"
          stroke="none"
        />
        <path
          d="M115 150 Q99 169 119 172 L143 172 Q148 161 137 157"
          fill="#fffdf4"
        />
        <path
          d="M181 151 Q181 171 195 171 L218 171 Q223 160 202 155"
          fill="#fffdf4"
        />
        <path
          d="M88 62 Q117 50 124 81 L120 128 Q117 150 95 153 Q66 150 64 124 L63 93 Q62 72 88 62Z"
          fill="#fffdf4"
        />
        <path
          d="M81 65 Q52 45 48 79 L50 108 Q59 122 70 99 L79 82"
          fill="#8e654c"
        />
        <path
          d="M111 65 Q130 50 139 70 Q148 97 134 112 Q125 116 119 99"
          fill="#8e654c"
        />
        <path
          d="M86 113 Q65 108 58 122 Q50 135 71 139 L101 135"
          fill="#fffdf4"
        />
        <ellipse cx="61" cy="123" rx="8" ry="6" fill="#343b35" />
        {stage < 3 ? (
          <>
            <ellipse
              cx="84"
              cy="98"
              rx="3.1"
              ry="4.3"
              fill="#343b35"
              stroke="none"
            />
            <ellipse
              cx="108"
              cy="98"
              rx="3.1"
              ry="4.3"
              fill="#343b35"
              stroke="none"
            />
          </>
        ) : (
          <>
            <path d="M78 99q6-6 12 0M102 99q6-6 12 0" fill="none" />
          </>
        )}
        <path d="M83 128 Q88 134 95 128" fill="none" />
        <path
          d="M69 143 Q90 152 115 143 L116 151 Q94 160 72 151Z"
          fill="#d77860"
        />
        <circle cx="96" cy="156" r="6" fill="#e8bb68" strokeWidth="2" />
        <path d="M80 169v-5m7 6v-5m112 5v-5m7 5v-4" />
      </g>
      <g className="buddy-hearts" fill="#db927c">
        <path d="M179 44c-12-14-21 2 0 14 21-12 12-28 0-14Z" />
        <path d="M211 66c-8-9-14 1 0 10 14-9 8-19 0-10Z" />
      </g>
      {stage >= 3 && (
        <text
          x="177"
          y="63"
          fill="#6f8777"
          fontSize="21"
          fontFamily="Georgia"
          transform="rotate(10 177 63)"
        >
          z z
        </text>
      )}
      {!compact && (
        <g fill="#9fa98e">
          <path d="M28 163q-5-12-8-6 0 7 8 10m0-4q5-15 9-7-2 8-9 11" />
          <path d="M238 170q-4-11-7-6 0 6 7 9m0-3q4-12 8-6-2 7-8 9" />
        </g>
      )}
    </svg>
  );
}
